////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { find, isUndefined } from 'lodash'
import { kioskCustomerRequestStatusPicsConfig } from '../../../constants/AssetsPicturesConfigList'

//////STYLED//////
const InitKioskCustomerRequestStatusWrapper = styled.div`
	text-align: left;
	margin: 0px 10px;
	& * {
		display: inline-block;
		vertical-align: middle;
	}
	& img {
		margin-right: 12px;
	}
`
//////STYLED//////

const InitKioskCustomerRequestStatus = (props) => {
	const f = find(kioskCustomerRequestStatusPicsConfig, { subFlow: props.row.requestStatus.subFlow })

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<InitKioskCustomerRequestStatusWrapper>
			{!isUndefined(f) && <img src={`${f.picture}`} />}
			<span>{translations[props.row.requestStatus.translationKey]}</span>
		</InitKioskCustomerRequestStatusWrapper>
	)
}

InitKioskCustomerRequestStatus.propTypes = {}

InitKioskCustomerRequestStatus.defaultPropTypes = {}

export default InitKioskCustomerRequestStatus
